import {AudioBridgeEvent} from "../../../constants/Janus/AudioBridge";

export const attachAudioBridge = (Janus: any, janus: any, opaqueId: string, callback: any) => {
    let mixer: any = null;

    if (!janus) return;

    janus.attach(
        {
            plugin: "janus.plugin.audiobridge",
            opaqueId: opaqueId,
            success: function (pluginHandle: any) {
                // $('#details').remove();
                mixer = pluginHandle;
                Janus.log("Plugin attached! (" + mixer.getPlugin() + ", id=" + mixer.getId() + ")");
                // Prepare the username registration
                // $('#audiojoin').removeClass('hide').show();
                // $('#registernow').removeClass('hide').show();
                // $('#register').click(registerUsername);
                // $('#username').focus();
                // $('#start').removeAttr('disabled').html("Stop")
                //     .click(function() {
                //         $(this).attr('disabled', true);
                //         janus.destroy();
                //     });
                callback(mixer, AudioBridgeEvent.SUCCESS);
            },
            error: function (error: any) {
                Janus.error("  -- Error attaching plugin...", error);
                // bootbox.alert("Error attaching plugin... " + error);
                callback(mixer, AudioBridgeEvent.ERROR, error);
            },
            consentDialog: function (on: boolean) {
                Janus.debug("Consent dialog should be " + (on ? "on" : "off") + " now");
                // if(on) {
                //     // Darken screen and show hint
                //     $.blockUI({
                //         message: '<div><img src="up_arrow.png"/></div>',
                //         css: {
                //             border: 'none',
                //             padding: '15px',
                //             backgroundColor: 'transparent',
                //             color: '#aaa',
                //             top: '10px',
                //             left: (navigator.mozGetUserMedia ? '-100px' : '300px')
                //         } });
                // } else {
                //     // Restore screen
                //     $.unblockUI();
                // }
                callback(mixer, AudioBridgeEvent.CONSENT_DIALOG, on);
            },
            iceState: function (state: any) {
                Janus.log("ICE state changed to " + state);
                callback(mixer, AudioBridgeEvent.ICE_STATE, state);
            },
            mediaState: function (medium: any, on: boolean) {
                Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium);
                callback(mixer, AudioBridgeEvent.MEDIA_STATE, {medium, on});
            },
            webrtcState: function (on: boolean) {
                Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
                callback(mixer, AudioBridgeEvent.WEBRTC_STATE, on);
            },
            onmessage: function (msg: any, jsep: any) {
                Janus.debug(" ::: Got a message :::", msg);
                let event = msg["audiobridge"];
                Janus.debug("Event: " + event);
                if (event) {
                    if (event === "joined") {
                        // Successfully joined, negotiate WebRTC now
                        // if(msg["id"]) {
                        // myid = msg["id"];
                        // Janus.log("Successfully joined room " + msg["room"] + " with ID " + myid);
                        // if(!webrtcUp) {
                        //     webrtcUp = true;
                        //     // Publish our stream
                        //     mixertest.createOffer(
                        //         {
                        //             media: { video: false },	// This is an audio only room
                        //             customizeSdp: function(jsep) {
                        //                 if(stereo && jsep.sdp.indexOf("stereo=1") == -1) {
                        //                     // Make sure that our offer contains stereo too
                        //                     jsep.sdp = jsep.sdp.replace("useinbandfec=1", "useinbandfec=1;stereo=1");
                        //                 }
                        //             },
                        //             success: function(jsep) {
                        //                 Janus.debug("Got SDP!", jsep);
                        //                 var publish = { request: "configure", muted: false };
                        //                 mixertest.send({ message: publish, jsep: jsep });
                        //             },
                        //             error: function(error) {
                        //                 Janus.error("WebRTC error:", error);
                        //                 bootbox.alert("WebRTC error... " + error.message);
                        //             }
                        //         });
                        // }
                        // }
                        // Any room participant?
                        // if(msg["participants"]) {
                        //     var list = msg["participants"];
                        //     Janus.debug("Got a list of participants:", list);
                        //     for(var f in list) {
                        //         var id = list[f]["id"];
                        //         var display = escapeXmlTags(list[f]["display"]);
                        //         var setup = list[f]["setup"];
                        //         var muted = list[f]["muted"];
                        //         var spatial = list[f]["spatial_position"];
                        //         Janus.debug("  >> [" + id + "] " + display + " (setup=" + setup + ", muted=" + muted + ")");
                        //         if($('#rp' + id).length === 0) {
                        //             // Add to the participants list
                        //             var slider = '';
                        //             if(spatial !== null && spatial !== undefined)
                        //                 slider = '<span>[L <input id="sp' + id + '" type="text" style="width: 10%;"/> R] </span>';
                        //             $('#list').append('<li id="rp' + id +'" class="list-group-item">' +
                        //                 slider +
                        //                 display +
                        //                 ' <i class="absetup fa fa-chain-broken"></i>' +
                        //                 ' <i class="abmuted fa fa-microphone-slash"></i></li>');
                        //             if(spatial !== null && spatial !== undefined) {
                        //                 $('#sp' + id).slider({ min: 0, max: 100, step: 1, value: 50, handle: 'triangle', enabled: false });
                        //                 $('#position').removeClass('hide').show();
                        //             }
                        //             $('#rp' + id + ' > i').hide();
                        //         }
                        //         if(muted === true || muted === "true")
                        //             $('#rp' + id + ' > i.abmuted').removeClass('hide').show();
                        //         else
                        //             $('#rp' + id + ' > i.abmuted').hide();
                        //         if(setup === true || setup === "true")
                        //             $('#rp' + id + ' > i.absetup').hide();
                        //         else
                        //             $('#rp' + id + ' > i.absetup').removeClass('hide').show();
                        //         if(spatial !== null && spatial !== undefined)
                        //             $('#sp' + id).slider('setValue', spatial);
                        //     }
                        // }
                        callback(mixer, AudioBridgeEvent.JOINED, msg);
                    } else if (event === "roomchanged") {
                        // The user switched to a different room
                        // myid = msg["id"];
                        // Janus.log("Moved to room " + msg["room"] + ", new ID: " + myid);
                        // Any room participant?
                        // $('#list').empty();
                        // if(msg["participants"]) {
                        //     var list = msg["participants"];
                        //     Janus.debug("Got a list of participants:", list);
                        //     for(var f in list) {
                        //         var id = list[f]["id"];
                        //         var display = escapeXmlTags(list[f]["display"]);
                        //         var setup = list[f]["setup"];
                        //         var muted = list[f]["muted"];
                        //         var spatial = list[f]["spatial_position"];
                        //         Janus.debug("  >> [" + id + "] " + display + " (setup=" + setup + ", muted=" + muted + ")");
                        //         if($('#rp' + id).length === 0) {
                        //             // Add to the participants list
                        //             var slider = '';
                        //             if(spatial !== null && spatial !== undefined)
                        //                 slider = '<span>[L <input id="sp' + id + '" type="text" style="width: 10%;"/> R] </span>';
                        //             $('#list').append('<li id="rp' + id +'" class="list-group-item">' +
                        //                 slider +
                        //                 display +
                        //                 ' <i class="absetup fa fa-chain-broken"></i>' +
                        //                 ' <i class="abmuted fa fa-microphone-slash"></i></li>');
                        //             if(spatial !== null && spatial !== undefined) {
                        //                 $('#sp' + id).slider({ min: 0, max: 100, step: 1, value: 50, handle: 'triangle', enabled: false });
                        //                 $('#position').removeClass('hide').show();
                        //             }
                        //             $('#rp' + id + ' > i').hide();
                        //         }
                        //         if(muted === true || muted === "true")
                        //             $('#rp' + id + ' > i.abmuted').removeClass('hide').show();
                        //         else
                        //             $('#rp' + id + ' > i.abmuted').hide();
                        //         if(setup === true || setup === "true")
                        //             $('#rp' + id + ' > i.absetup').hide();
                        //         else
                        //             $('#rp' + id + ' > i.absetup').removeClass('hide').show();
                        //         if(spatial !== null && spatial !== undefined)
                        //             $('#sp' + id).slider('setValue', spatial);
                        //     }
                        // }
                        callback(mixer, AudioBridgeEvent.ROOM_CHANGED, msg);
                    } else if (event === "destroyed") {
                        // The room has been destroyed
                        Janus.warn("The room has been destroyed!");
                        // bootbox.alert("The room has been destroyed", function() {
                        //     window.location.reload();
                        // });
                        callback(mixer, AudioBridgeEvent.DESTROYED);
                    }  else if(event === "talking") {
                        Janus.log("Participant talking", msg);
                        // callback(mixer, "talking", msg);
                        callback(mixer, AudioBridgeEvent.TALKING, msg["id"])
                    } else if(event === "stopped-talking") {
                        Janus.log("Participant stopped talking", msg);
                        callback(mixer, AudioBridgeEvent.STOPPED_TALKING, msg["id"])
                        // callback(mixer, "stopped-talking", msg);
                    } else if (event === "event") {
                        if (msg["participants"]) {
                            // var list = msg["participants"];
                            // Janus.debug("Got a list of participants:", list);
                            // for(var f in list) {
                            //     var id = list[f]["id"];
                            //     var display = escapeXmlTags(list[f]["display"]);
                            //     var setup = list[f]["setup"];
                            //     var muted = list[f]["muted"];
                            //     var spatial = list[f]["spatial_position"];
                            //     Janus.debug("  >> [" + id + "] " + display + " (setup=" + setup + ", muted=" + muted + ")");
                            //     if($('#rp' + id).length === 0) {
                            //         // Add to the participants list
                            //         var slider = '';
                            //         if(spatial !== null && spatial !== undefined)
                            //             slider = '<span>[L <input id="sp' + id + '" type="text" style="width: 10%;"/> R] </span>';
                            //         $('#list').append('<li id="rp' + id +'" class="list-group-item">' +
                            //             slider +
                            //             display +
                            //             ' <i class="absetup fa fa-chain-broken"></i>' +
                            //             ' <i class="abmuted fa fa-microphone-slash"></i></li>');
                            //         if(spatial !== null && spatial !== undefined) {
                            //             $('#sp' + id).slider({ min: 0, max: 100, step: 1, value: 50, handle: 'triangle', enabled: false });
                            //             $('#position').removeClass('hide').show();
                            //         }
                            //         $('#rp' + id + ' > i').hide();
                            //     }
                            //     if(muted === true || muted === "true")
                            //         $('#rp' + id + ' > i.abmuted').removeClass('hide').show();
                            //     else
                            //         $('#rp' + id + ' > i.abmuted').hide();
                            //     if(setup === true || setup === "true")
                            //         $('#rp' + id + ' > i.absetup').hide();
                            //     else
                            //         $('#rp' + id + ' > i.absetup').removeClass('hide').show();
                            //     if(spatial !== null && spatial !== undefined)
                            //         $('#sp' + id).slider('setValue', spatial);
                            // }
                            callback(mixer, AudioBridgeEvent.PARTICIPANTS, msg["participants"]);
                        } else if (msg["error"]) {
                            // if(msg["error_code"] === 485) {
                            //     // This is a "no such room" error: give a more meaningful description
                            //     bootbox.alert(
                            //         "<p>Apparently room <code>" + myroom + "</code> (the one this demo uses as a test room) " +
                            //         "does not exist...</p><p>Do you have an updated <code>janus.plugin.audiobridge.jcfg</code> " +
                            //         "configuration file? If not, make sure you copy the details of room <code>" + myroom + "</code> " +
                            //         "from that sample in your current configuration file, then restart Janus and try again."
                            //     );
                            // } else {
                            //     bootbox.alert(msg["error"]);
                            // }
                            // return;
                            callback(mixer, AudioBridgeEvent.ERROR_EVENT, msg);
                        }
                        // Any new feed to attach to?
                        if (msg["leaving"]) {
                            // One of the participants has gone away?
                            let leaving = msg["leaving"];
                            Janus.log("Participant left: " + leaving + " (we have " + $('#rp' + leaving).length + " elements with ID #rp" + leaving + ")");
                            // $('#rp'+leaving).remove();
                            callback(mixer, AudioBridgeEvent.LEAVING, msg["leaving"]);
                        }
                    }
                }
                if (jsep) {
                    Janus.debug("Handling SDP as well...", jsep);
                    mixer.handleRemoteJsep({jsep: jsep});
                }
            },
            onlocalstream: function (stream: any) {
                Janus.debug(" ::: Got a local stream :::", stream);
                // We're not going to attach the local audio stream
                // $('#audiojoin').hide();
                // $('#room').removeClass('hide').show();
                // $('#participant').removeClass('hide').html(myusername).show();
            },
            onremotestream: function (stream: any) {
                // $('#room').removeClass('hide').show();
                // var addButtons = false;
                // if($('#roomaudio').length === 0) {
                //     addButtons = true;
                //     $('#mixedaudio').append('<audio class="rounded centered" id="roomaudio" width="100%" height="100%" autoplay/>');
                // }
                // Janus.attachMediaStream($('#roomaudio').get(0), stream);
                // if(!addButtons)
                //     return;
                // // Mute button
                // audioenabled = true;
                // $('#toggleaudio').click(
                //     function() {
                //         audioenabled = !audioenabled;
                //         if(audioenabled)
                //             $('#toggleaudio').html("Mute").removeClass("btn-success").addClass("btn-danger");
                //         else
                //             $('#toggleaudio').html("Unmute").removeClass("btn-danger").addClass("btn-success");
                //         mixer.send({ message: { request: "configure", muted: !audioenabled }});
                //     }).removeClass('hide').show();
                // // Spatial position, if enabled
                // $('#position').click(
                //     function() {
                //         bootbox.prompt("Insert new spatial position: [0-100] (0=left, 50=center, 100=right)", function(result) {
                //             var spatial = parseInt(result);
                //             if(isNaN(spatial) || spatial < 0 || spatial > 100) {
                //                 bootbox.alert("Invalid value");
                //                 return;
                //             }
                //             mixer.send({ message: { request: "configure", spatial_position: spatial }});
                //         });
                //     });
                callback(mixer, AudioBridgeEvent.ON_REMOTE_STREAM, stream);
            },
            oncleanup: function () {
                // webrtcUp = false;
                Janus.log(" ::: Got a cleanup notification :::");
                // $('#participant').empty().hide();
                // $('#list').empty();
                // $('#mixedaudio').empty();
                // $('#room').hide();
                callback(mixer, AudioBridgeEvent.ON_CLEAN_UP)
            }
        });
}

export const joinAudioRoom = (mixerPlugin: any, roomId: number, display: string, muted = false, volume = 100) => {
    let requestJoinMsg = {
        request: "join",
        room: roomId,
        display: display,
        muted: muted,
        // volume: volume
    };
    mixerPlugin.send({ message: requestJoinMsg });
}

export const publishAudio = (Janus: any, mixerPlugin: any, muted = false, callback: any) => {
    mixerPlugin.createOffer(
        {
            media: { video: false },	// This is an audio only room
            success: function(jsep: any) {
                Janus.debug("Got SDP!");
                Janus.debug(jsep);
                let publish = { "request": "configure", "muted": muted };
                mixerPlugin.send({"message": publish, "jsep": jsep});
                callback("success", muted);
            },
            error: function(error: any) {
                Janus.error("WebRTC error:", error);
                callback("error", error);
            }
        });
};